<div class="denial-reason-dialog">
    <app-dialog-title
        [title]="mode === 'add'
            ? ('pages.config-all.denial-reasons.dialog.addTitle' | translate)
            : ('pages.config-all.denial-reasons.dialog.editTitle' | translate)"
        (close)="cancel()">
    </app-dialog-title>

    <mat-dialog-content>
        <app-bciti-tabs>
            <app-bciti-tab *ngFor="let lang of langs" [title]="'pages.config-all.denial-reasons.langs.' + lang | translate">
                <div [formGroup]="getLangGroup(lang)" class="form-fields">
                    <app-form-input
                        label="{{ getFieldLabel('titleLabel', lang) }}"
                        placeholder="{{ getFieldLabel('titlePlaceholder', lang) }}"
                        formControlName="title">
                        <app-form-error *ngIf="getLangGroup(lang).get('title').touched && getLangGroup(lang).get('title').hasError('required')">
                            {{ getFieldLabel('errors.titleRequired', lang) }}
                        </app-form-error>
                    </app-form-input>

                    <app-form-textarea
                        label="{{ getFieldLabel('internalDescriptionLabel', lang) }}"
                        placeholder="{{ getFieldLabel('internalDescriptionPlaceholder', lang) }}"
                        formControlName="internalDescription"
                        [rows]="3">
                    </app-form-textarea>

                    <app-form-textarea
                        label="{{ getFieldLabel('citizenReasonLabel', lang) }}"
                        placeholder="{{ getFieldLabel('citizenReasonPlaceholder', lang) }}"
                        formControlName="citizenReason"
                        [rows]="3">
                        <app-form-error *ngIf="getLangGroup(lang).get('citizenReason').touched && getLangGroup(lang).get('citizenReason').hasError('required')">
                            {{ getFieldLabel('errors.citizenReasonRequired', lang) }}
                        </app-form-error>
                    </app-form-textarea>
                </div>
            </app-bciti-tab>
        </app-bciti-tabs>
    </mat-dialog-content>

    <footer class="dialog-footer">
        <button class="bciti-button bciti-button--black-inversed" (click)="cancel()">
            {{ 'pages.config-all.denial-reasons.dialog.cancelButton' | translate }}
        </button>
        <button class="bciti-button bciti-button--blue" (click)="submit()">
            {{ 'pages.config-all.denial-reasons.dialog.submitButton' | translate }}
        </button>
    </footer>
</div>
